export default "__VITE_ASSET__BMz$eeAt__"